// import Vue from "vue";
/* eslint-disable no-constant-condition */

import axios from "@/axios.js";
import endpoints from "@/endpoints";
// import uuidv1 from "uuid";
import { v1 as uuidv1 } from "uuid";
import { flatMap } from "lodash";

export function arrayOfStrings(str, count = 1, arr = []) {
    return arr.length < count ? arrayOfStrings(str, count, [...arr, str]) : arr;
}

export function shuffleArray(arr) {
    const array = [...arr];
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}
/* eslint-disable no-constant-condition */

export default class Autosomal {
    static async getResults({ barcode, query }) {
        const { data } = await axios.get(`${endpoints.tests}/${barcode}/family?view=${query}`);
        return data;
    }

    static async getSummary(barcode) {
        /* eslint-disable */
        const { data } = await axios.get(`${endpoints.tests}/${barcode}/summary`);

        return data;
    }

    static async getHistory({ barcode, groupId }) {
        const { data } = await axios.get(`${endpoints.tests}/${barcode}/history/${groupId}`);

        return data;
    }
}
/* eslint-disable no-constant-condition */

export async function getPreviousResult(barcode) {
    return await axios.get(endpoints.getPreviousAutosomalResult(barcode));
}

export function createMapItem(item) {
    return {
        properties: {
            colour: item.colour,
            title: item.title,
            // Null, never a generated id. `code` is what the Mapbox layers filter on
            // (MapLayer/ActiveLayer in mapHelpers.js), so substituting a uuid produced a
            // layer that could never match a feature - a silent no-op instead of an item
            // the caller can recognise as unmappable and skip.
            code: item.code ?? null,
            percentage: item.percentage || 1,
            group: item.groupId || uuidv1(),
            childrenCount: item.children.length,
        },
        id: item.groupId || uuidv1(),
    };
}

export function flattenChildren(array) {
    return flatMap(array, "children");
}

function removeInnerChildren(arr) {
    return arr.map(({ ...rest }) => rest);
}

export function normaliseSubRegionalLevel(arr) {
    return arr.map((region) => ({
        ...region,
        isParent: true,
        parentLevel: 1,
        children: region.children.map((subRegion) => ({
            ...subRegion,
            isParent: true,
            parentLevel: 2,
            children: removeInnerChildren(subRegion.children),
        })),
    }));
}
